module.exports = function () {

	//$('.A1-header__search-button').click(function() {
	//	$(this).closest('.A1-header').toggleClass('has-search-active');
	//});

	var $container = $('.site-search-bar');

	if ($container.length) {
		var typeAheadObject = Innophos.Modules.SiteSearchBar.TypeAhead($container);
		Innophos.Modules.SiteSearchBar.TypeAheadDropdown($container);
		Innophos.Modules.SiteSearchBar.StripSpecialCharacters();

		var $searchInput = $('.site-search-bar .generic-search-bar__input');
		var $searchInner = $('.site-search-bar .generic-search-bar__inner');
		var searchInnerActiveClass = 'has-suggestions';

		$searchInput.focusout(function () {
			$searchInner.removeClass(searchInnerActiveClass);
		});

		$searchInput.focus(function () {
			var currentVal = $(this).val();

			if (!currentVal.length) {
				$searchInner.addClass(searchInnerActiveClass);
			}
			else {
				$searchInner.removeClass(searchInnerActiveClass);
			}
		});

		$searchInput.on('input', function (e) {
			var currentVal = $searchInput.val();
			if (!currentVal.length) {
				$searchInner.addClass(searchInnerActiveClass);
			}
			else if (!$searchInner.hasClass('has-dropdown-suggestions')) {
				$searchInner.removeClass(searchInnerActiveClass);
			}
		});

		var setClearButtonVisibility = function (inputValue) {
			if (inputValue) {
				$container.find('.search-bar__reset').addClass('search-bar__reset--visible');
			} else {
				$container.find('.search-bar__reset').removeClass('search-bar__reset--visible');
				typeAheadObject.clearTypeAhead();
			}
		};

		$searchInput.keyup(function () {
			setClearButtonVisibility($(this).val());
		});

		$container.find('.search-bar__reset').click(function () {
			setClearButtonVisibility();
		});


		var searchPageContentTop = $('.search-page__content').offset().top;
		var searchPageContentHeight = $('.search-page__content').height();
		var headerHeight = $('.A1-header').height();
		var containerHeight = $container.height();

		var resetOffsets = function() {
			searchPageContentTop = $('.search-page__content').offset().top;
			searchPageContentHeight = $('.search-page__content').height();
			headerHeight = $('.A1-header').height();
			containerHeight = $container.height();
		}

		var setBarPosition = () => {
			var barActiveClass = 'site-search-bar--fixed';
			if ($(window).scrollTop() && $(window).scrollTop() < searchPageContentTop + searchPageContentHeight - headerHeight - containerHeight) {
				$container.addClass(barActiveClass);
			}
			else {
				$container.removeClass(barActiveClass);
			}
		};

		$(window).scroll(function () {
			requestAnimationFrame(setBarPosition);
		});

		$(window).resize(function () {
			resetOffsets();
			requestAnimationFrame(setBarPosition);
		});

		setBarPosition();
	}
};
